var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import jsBridge from './utils/bridge.mjs';
import { API_SET_NAVIGATION_BAR, API_SET_STATUS_BAR_STYLE, API_SWITCH_POP_GESTURE, API_CUSTOM_BACK, EVENT_BACK_INVOKED } from './utils/constant.mjs';
import { historyBack } from './route.mjs';
/**
 * 设置导航栏
 * @returns
 */
export function setNavigationBar(params = {}) {
    if (!('hide' in params)) {
        params.hide = false;
    }
    return jsBridge.callPromise({
        minVersion: '1.0.4'
    }, API_SET_NAVIGATION_BAR, params);
}
/**
 * 状态栏样式
 */
export var StatusBarStyle;
(function (StatusBarStyle) {
    /**
     * 黑色字体
     */
    StatusBarStyle[StatusBarStyle["Black"] = 1] = "Black";
    /**
     * 白色字体
     */
    StatusBarStyle[StatusBarStyle["White"] = 2] = "White";
})(StatusBarStyle || (StatusBarStyle = {}));
/**
 * 设置状态栏
 * @returns
 */
export function setStatusBarStyle(params = {}) {
    if (!params.style) {
        params.style = StatusBarStyle.Black;
    }
    return jsBridge.callPromise({
        minVersion: '1.0.4'
    }, API_SET_STATUS_BAR_STYLE, params);
}
/**
 * 切换右滑返回（ios）
 * @param params
 * @returns
 */
export function switchPopGesture(params = {}) {
    if (!('enable' in params)) {
        params.enable = true;
    }
    return jsBridge.callPromise({
        minVersion: '1.0.8'
    }, API_SWITCH_POP_GESTURE, params);
}
let backInited = false;
let backHandler = null;
/**
 * 自定义返回
 * @param params
 * @returns
 */
export function customBack(params = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!('enable' in params)) {
            params.enable = false;
        }
        if (params.enable) {
            backHandler = params.handler;
            if (!backInited) {
                backInited = true;
                jsBridge.addEventListener(EVENT_BACK_INVOKED, () => {
                    if (backHandler) {
                        backHandler();
                    }
                    else {
                        historyBack();
                    }
                });
            }
        }
        const res = yield jsBridge.callPromise({
            minVersion: '1.0.8',
            noResponse: true
        }, API_CUSTOM_BACK, params);
        if (!res.error && params.enable) {
            res.data.removeHandler = () => {
                if (backHandler === params.handler) {
                    backHandler = null;
                    jsBridge.callPromise({
                        minVersion: '1.0.8'
                    }, API_CUSTOM_BACK, {
                        enable: false
                    });
                }
            };
        }
        return res;
    });
}
